export default __webpack_public_path__ + "static/media/g2.fcb2bd7c.png";